const protocol = location.protocol;

const ENDPOINT_CONFIG_DEFAULT = {
  root: `${protocol}//social-dash.com`,
  api: `${protocol}//social-dash.com/api`,
};

export const environment = {
  production: true,
  aiCopilotDebug: false,
  mobile: false,
  rootUrl: ENDPOINT_CONFIG_DEFAULT.root,
  apiUrl: ENDPOINT_CONFIG_DEFAULT.api,
  adminEmail: 'admin@social-dash.com',
  salesEmail: 'admin@social-dash.com',
  deviceKey: '',
  openAiModel: 'gpt-4o-mini'
};